<div
  class="select-trigger"
  [class.open]="isOpen"
  [class.disabled]="isDisabled"
  tabindex="0"
  (click)="toggleDropdown()"
>
  <span class="select-trigger__label" [class.select-trigger__label--placeholder]="!hasValue">
    <ng-container *ngIf="triggerTemplate && hasValue; else defaultTrigger">
      <ng-container *ngTemplateOutlet="triggerTemplate.templateRef; context: triggerContext">
      </ng-container>
    </ng-container>
    <ng-template #defaultTrigger>
      {{ hasValue ? selectedOption?.labelText : placeholder }}
    </ng-template>
  </span>
  <i
    class="select-trigger__chevron"
    [class.icon--chevron-down]="!isOpen"
    [class.icon--chevron-up]="isOpen"
  ></i>
</div>

<div #dropdown class="select-dropdown" *ngIf="isOpen" [class.open-up]="openUp">
  <ng-content></ng-content>
</div>
